import React from 'react';

import { ViewStyle } from 'react-native';

import { RightArrowSettings } from 'assets/images';

import SvgButton from 'components/CustomButtons/SvgButton';

import styles from './styles';

const ARROW_ICON_SIZE = {
    width: 9,
    height: 18,
};

type Props = {
    onPress(): void;
    style?: ViewStyle;
    onKeyDownCapture?(event: KeyboardEvent): void;
    tabIndex?: number;
    testID?: string;
    accessibilityLabel?: string;
};

function WebArrowButton({
    onPress,
    onKeyDownCapture,
    style,
    tabIndex,
    testID,
    accessibilityLabel,
}: Props) {
    return (
        <SvgButton
            Svg={RightArrowSettings}
            onPress={onPress}
            onKeyDownCapture={onKeyDownCapture}
            style={[
                styles.arrowButton,
                style,
                {
                    // @ts-ignore
                    outline: 'none',
                },
            ]}
            svgStyle={ARROW_ICON_SIZE}
            tabIndex={tabIndex}
            testID={testID}
            accessibilityLabel={accessibilityLabel}
            accessible
        />
    );
}

export default WebArrowButton;
